(function() {
  let cachedCards = null;
  let paginationHTMLs = {};
  let totalPages = 1;
  let currentPage = 1;
  let pageSize = 24;
  let sectionId = '';
  let isLoading = false;
  let hideUnavailable = false;

  function getGridEl() {
    return document.getElementById('product-grid');
  }

  function getGridList(gridEl) {
    return (
      document.querySelector('#product-grid ul.grid') ||
      document.querySelector('#product-grid.grid') ||
      document.querySelector('#product-grid .grid') ||
      gridEl
    );
  }

  function isHideUnavailable(gridEl) {
    return gridEl?.dataset.hideUnavailable === 'true';
  }

  function availableFirst(a, b) {
    const aAvail = a.getAttribute('data-available') === 'true' ? 1 : 0;
    const bAvail = b.getAttribute('data-available') === 'true' ? 1 : 0;
    return bAvail - aAvail;
  }

  function inStockCards(cards) {
    return cards.filter((card) => card.getAttribute('data-available') === 'true');
  }

  function pageHref(pageNumber) {
    const url = new URL(window.location.href);
    if (pageNumber <= 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', String(pageNumber));
    }
    return `${url.pathname}${url.search}${url.hash}`;
  }

  function caretMarkup(pagWrapper, kind) {
    const existing = pagWrapper?.querySelector(
      kind === 'prev' ? '.pagination__item--next' : '.pagination__item--prev'
    );
    if (existing) return existing.innerHTML;
    return '<span aria-hidden="true">‹</span>';
  }

  function updateProductCount(count) {
    ['ProductCount', 'ProductCountDesktop'].forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;
      el.textContent = count === 1 ? 'מוצר 1' : `${count} מוצרים`;
    });
  }

  function rebuildPagination(pageNumber) {
    const collectionEl = document.getElementById('ProductGridContainer')?.querySelector('.collection');
    if (!collectionEl) return;

    let pagWrapper = collectionEl.querySelector('.pagination-wrapper');

    if (totalPages <= 1) {
      if (pagWrapper) pagWrapper.remove();
      return;
    }

    const caretPrev = caretMarkup(pagWrapper, 'prev');
    const caretNext = caretMarkup(pagWrapper, 'next');
    const parts = [];

    if (pageNumber > 1) {
      parts.push(
        `<li><a href="${pageHref(pageNumber - 1)}" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" aria-label="Previous">${caretPrev}</a></li>`
      );
    }

    for (let p = 1; p <= totalPages; p += 1) {
      if (totalPages > 7 && p > 2 && p < totalPages - 1 && Math.abs(p - pageNumber) > 1) {
        if (p === 3 || p === totalPages - 2) {
          parts.push('<li><span class="pagination__item">…</span></li>');
        }
        continue;
      }
      if (p === pageNumber) {
        parts.push(
          `<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page">${p}</a></li>`
        );
      } else {
        parts.push(`<li><a href="${pageHref(p)}" class="pagination__item link">${p}</a></li>`);
      }
    }

    if (pageNumber < totalPages) {
      parts.push(
        `<li><a href="${pageHref(pageNumber + 1)}" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" aria-label="Next">${caretNext}</a></li>`
      );
    }

    const html = `<div class="pagination-wrapper"><nav class="pagination" role="navigation"><ul class="pagination__list list-unstyled" role="list">${parts.join('')}</ul></nav></div>`;

    if (pagWrapper) {
      pagWrapper.outerHTML = html;
    } else {
      collectionEl.insertAdjacentHTML('beforeend', html);
    }
  }

  async function initSorting() {
    if (isLoading) return;
    const gridEl = getGridEl();
    if (!gridEl) return;

    sectionId = gridEl.dataset.id;
    pageSize = parseInt(gridEl.dataset.pageSize || '24', 10);
    hideUnavailable = isHideUnavailable(gridEl);

    const pagWrapper = document.querySelector('.pagination-wrapper');
    const pageLinks = pagWrapper ? pagWrapper.querySelectorAll('nav.pagination a') : [];

    totalPages = 1;
    if (pagWrapper) {
      pageLinks.forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        const p = parseInt(url.searchParams.get('page') || '1', 10);
        if (p > totalPages) totalPages = p;
      });
    }

    const urlParams = new URLSearchParams(window.location.search);
    currentPage = parseInt(urlParams.get('page') || '1', 10);

    if (totalPages <= 1) {
      sortInPlace();
      return;
    }

    isLoading = true;
    const container = document.getElementById('ProductGridContainer')?.querySelector('.collection');
    if (container) container.classList.add('loading');

    paginationHTMLs = {};
    paginationHTMLs[currentPage] = pagWrapper ? pagWrapper.outerHTML : '';

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete('page');
    searchParams.set('section_id', sectionId);

    const fetchPage = async (p) => {
      if (p === currentPage) {
        return Array.from(document.querySelectorAll('#product-grid li.grid__item'));
      }
      try {
        const params = new URLSearchParams(searchParams);
        params.set('page', p);
        const response = await fetch(`${window.location.pathname}?${params.toString()}`);
        if (!response.ok) throw new Error(`Failed to fetch page ${p}`);
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        const cards = Array.from(doc.querySelectorAll('#product-grid li.grid__item'));
        const pWrapper = doc.querySelector('.pagination-wrapper');
        paginationHTMLs[p] = pWrapper ? pWrapper.outerHTML : '';
        return cards;
      } catch (err) {
        console.error('Error pre-fetching page:', p, err);
        return [];
      }
    };

    const promises = [];
    for (let p = 1; p <= totalPages; p += 1) {
      promises.push(fetchPage(p));
    }

    try {
      const allPagesCards = await Promise.all(promises);
      const flatCards = allPagesCards.flat();

      if (hideUnavailable) {
        cachedCards = inStockCards(flatCards);
        totalPages = Math.max(1, Math.ceil(cachedCards.length / pageSize));
        if (currentPage > totalPages) currentPage = totalPages;
        updateProductCount(cachedCards.length);
      } else {
        flatCards.sort(availableFirst);
        cachedCards = flatCards;
      }

      renderPage(currentPage);
    } catch (err) {
      console.error('Error sorting products:', err);
    } finally {
      isLoading = false;
      if (container) container.classList.remove('loading');
    }
  }

  function sortInPlace() {
    const gridEl = getGridEl();
    const grid = getGridList(gridEl);
    if (!grid) return;
    let cards = Array.from(document.querySelectorAll('#product-grid li.grid__item'));
    if (hideUnavailable) {
      cards = inStockCards(cards);
      updateProductCount(cards.length);
      totalPages = 1;
      const pagWrapper = document.querySelector('.pagination-wrapper');
      if (pagWrapper) pagWrapper.remove();
    } else {
      cards.sort(availableFirst);
    }
    grid.innerHTML = '';
    cards.forEach((card, index) => {
      card.style.setProperty('--index', index);
      grid.appendChild(card);
    });
  }

  function renderPage(pageNumber) {
    if (!cachedCards) return;
    const gridEl = getGridEl();
    const grid = getGridList(gridEl);
    if (!grid) return;

    grid.innerHTML = '';
    const start = (pageNumber - 1) * pageSize;
    const end = start + pageSize;
    const slice = cachedCards.slice(start, end);
    slice.forEach((card, index) => {
      card.style.setProperty('--index', index);
      grid.appendChild(card);
    });

    if (hideUnavailable) {
      rebuildPagination(pageNumber);
    } else {
      const pagWrapper = document.querySelector('.pagination-wrapper');
      if (pagWrapper && paginationHTMLs[pageNumber]) {
        pagWrapper.outerHTML = paginationHTMLs[pageNumber];
      }
    }

    bindPaginationClicks();
  }

  function bindPaginationClicks() {
    const pagWrapper = document.querySelector('.pagination-wrapper');
    if (!pagWrapper) return;
    const links = pagWrapper.querySelectorAll('nav.pagination a');
    links.forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const url = new URL(link.href, window.location.origin);
        const p = parseInt(url.searchParams.get('page') || '1', 10);

        currentPage = p;

        const newUrlParams = new URLSearchParams(window.location.search);
        if (p <= 1) {
          newUrlParams.delete('page');
        } else {
          newUrlParams.set('page', p);
        }
        const query = newUrlParams.toString();
        const newUrl = query ? `${window.location.pathname}?${query}` : window.location.pathname;

        history.pushState({ searchParams: newUrlParams.toString() }, '', newUrl);

        renderPage(p);

        const container = document.getElementById('ProductGridContainer');
        if (container) {
          container.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSorting);
  } else {
    initSorting();
  }

  document.dispatchEvent(new CustomEvent('grid-rendered'));
  document.addEventListener('grid-rendered', initSorting);
})();
